import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSliceHook } from '../helpers';

const STORAGE_KEY = 'externalUserView';

export enum ViewType {
  EXTERNAL = 'external',
  SECONDARY = 'secondary',
}

export type ViewTypeValue = ViewType;

export interface ExternalUserViewState {
  currentView: ViewType;
}

// Initialize from localStorage or default to ViewType.EXTERNAL
const getInitialView = (): ViewType => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === ViewType.SECONDARY || stored === ViewType.EXTERNAL) {
      return stored as ViewType;
    }
  } catch (error) {
    console.error('Error reading from localStorage:', error);
  }
  return ViewType.EXTERNAL;
};

const initialState: ExternalUserViewState = {
  currentView: getInitialView(),
};

export const ExternalUserViewSlice = createSlice({
  name: 'ExternalUserView',
  initialState,
  reducers: {
    setView: (state, action: PayloadAction<ViewType>) => {
      state.currentView = action.payload;
      // Persist to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, action.payload);
      } catch (error) {
        console.error('Error writing to localStorage:', error);
      }
    },
    resetView: state => {
      state.currentView = ViewType.EXTERNAL;
      // Clear from localStorage
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        console.error('Error removing from localStorage:', error);
      }
    },
  },
});

export const { setView, resetView } = ExternalUserViewSlice.actions;

export const actions = {
  ...ExternalUserViewSlice.actions,
};

export const useExternalUserViewSlice = createSliceHook(
  ExternalUserViewSlice.name,
  actions
);

export const selectExternalUserViewState = createSelector(ExternalUserViewSlice.name);
